import PropTypes from 'prop-types'

import { audioMessageConfig } from '../audioMessageHelper'

const AudioMessage = ({ status, isPreview, text }) => {
  const { icon, className } = audioMessageConfig(isPreview ? 16 : 20)[status]

  return (
    <div className={`audio-message ${!isPreview ? 'audio-message__fullSize' : ''} ${className}`}>
      {icon}
      {text}
    </div>
  )
}

export default AudioMessage

AudioMessage.propTypes = {
  status: PropTypes.string,
  isPreview: PropTypes.bool,
  text: PropTypes.string,
}
